import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { getLabelCount } from '../fetchers/get-label-count';

export const useLabelCountSWR = (from: string, to: string) => {
    const { data, isLoading, error, mutate } = useSWR(
        ['label-count', from, to],
        () => getLabelCount(from, to),
        swrConfig
    );

    return { data, isLoading, error, mutate };
};
